export default "__VITE_ASSET__D8$ZnJsN__"